<script setup lang="ts">
import { BCol, BRow } from 'bootstrap-vue-next';

import MarkdownRenderer from '~/common/components/MarkdownRenderer.vue';
import ThemedOverlay from '~/common/components/ThemedOverlay.vue';

import aboutMarkdown from './transcend-hackathon-page/AboutSection.md?raw';
import TrackCard from './transcend-hackathon-page/TrackCard.vue';
</script>

<template>
  <ThemedOverlay>
    <MarkdownRenderer
      class="mt-3"
      :markdown-content="aboutMarkdown"
    />

    <BRow class="my-4">
      <BCol
        cols="12"
        md="6"
        class="mb-3"
      >
        <TrackCard
          title="Transcend Hackathon"
          action-name="Go to the Transcend Hackathon"
          button-variant="primary"
          :to="{ name: 'transcend-hackathon' }"
        >
          <p>
            Build agentic workflows on GitLab that automate any part of the
            software development lifecycle after the code is written, from
            review and testing through to deployment, monitoring, and
            incident response.
          </p>
          <p>
            Rewarded with cash prizes, awarded through Devpost.
          </p>
        </TrackCard>
      </BCol>
      <BCol
        cols="12"
        md="6"
        class="mb-3"
      >
        <TrackCard
          title="Community Hackathon"
          action-name="Go to the Community Hackathon"
          button-variant="primary"
          :to="{ name: 'hackathon' }"
        >
          <p>
            Make a real contribution to the projects and platform used by
            developers around the world. Choose an issue, improve the
            codebase, and work through GitLab's standard contribution
            process.
          </p>
          <p>
            Rewarded with GitLab swag credits.
          </p>
        </TrackCard>
      </BCol>
    </BRow>
  </ThemedOverlay>
</template>
